<template>
<div class="chapter">
<div class="inner_page">
<p class="copy"><span class="center">This eBook edition published in 2011 by<br/>
Birlinn Limited<br/>
West Newington House<br/>
Newington Road<br/>
Edinburgh<br/>
EH9 1QS<br/>
<a href="http://www.birlinn.co.uk" target="_blank"><i>www.birlinn.co.uk</i></a></span></p>
<p class="copy1"><span class="center">First published in 2002 by Deerpark Press, Selkirk<br/>
This edition first published in 2007 by Birlinn Limited</span></p>
<p class="copy1"><span class="center">Copyright © Alistair Moffatt 2002, 2007</span></p>
<p class="copy1"><span class="center">The moral right of Alistair Moffat to be identified as the author of this work has been asserted by him in accordance with the Copyright, Designs and Patents Act 1988</span></p>
<p class="copy1"><span class="center">All rights reserved. No part of this publication may be reproduced, stored or transmitted in any form without the express written permission of the publisher.</span></p>
<p class="copy1"><span class="center">All rights reserved. No part of this publication may be reproduced, stored or transmitted in any form without the express written permission of the publisher.</span></p>
<p class="copy1"><span class="center">eBook ISBN: 978-0-85790-114-9</span></p>
<p class="copy1"><span class="center">British Library Cataloguing-in-Publication Data<br/>
A catalogue record for this book is available from the British Library</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?0bb6617b